import { createFileRoute } from "@tanstack/react-router";
import { loadGameCategoryList, loadGameList } from "app/lib/loaders";
import { GamePage } from "pages/game";

export const Route = createFileRoute("/_auth/game/$gameId")({
  loader: () => Promise.all([loadGameCategoryList(), loadGameList()]),
  component: GamePage,
  onError: console.error,
});
